package locales.cldr.data

object metadata {
  lazy val isoCountries: Array[String] = // Auto-generated code from CLDR definitions, don't edit
  Array()
  lazy val isoLanguages: Array[String] = // Auto-generated code from CLDR definitions, don't edit
  Array()
  lazy val iso3Countries: Map[String, String] = // Auto-generated code from CLDR definitions, don't edit
  Map()
  lazy val iso3Languages: Map[String, String] = // Auto-generated code from ISO 639-2 data, don't edit
  Map()
  lazy val scripts: Array[String] = // Auto-generated code from CLDR definitions, don't edit
  Array()
}